import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { PrimengModule } from 'projects/ui-kit/src/lib/primeng.module';
import { UiKitModule } from 'projects/ui-kit/src/public-api';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { AuthModule } from '../../auth/auth.module';
import { HOME_COMPONENTS } from './components';
import { HomeComponent } from './home.component';
import { RequestFeatureComponent } from './components/request-feature/request-feature.component';

const routes: Route[] = [
  { path: '', component: HomeComponent}
]

@NgModule({
  declarations: [ HomeComponent, ...HOME_COMPONENTS],
  imports: [
    SharedModule,
    UiKitModule,
    PrimengModule,
    AuthModule,
    RequestFeatureComponent,
    RouterModule.forChild(routes)
  ],
  exports: HOME_COMPONENTS,
})
export class HomeModule { }
